<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <h5>{{ producto.descripcion }}</h5>
          <br />
          <v-form ref="formCatalogoProducto" :v-model="true" lazy-validation>
            <v-layout wrap class="container">
              <v-flex xs12 sm12 md12>
                <v-select
                  v-model="catalogoProducto.tallaId"
                  :items="tallas"
                  item-text="descripcion"
                  item-value="tallaId"
                  label="Talla"
                  :loading="loadingTallas"
                  placeholder="Talla"
                  single-line
                  :rules="[
                    () => !!catalogoProducto.tallaId || 'El campo es requerido',
                  ]"
                  required
                  :readonly="catalogoProducto.catalogoRowId !== 0"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select
                  v-model="catalogoProducto.colorId"
                  :items="colores"
                  item-text="nombre"
                  item-value="colorId"
                  label="Color"
                  :loading="loadingColores"
                  placeholder="Color"
                  single-line
                  :rules="[
                    () => !!catalogoProducto.colorId || 'El campo es requerido',
                  ]"
                  required
                  :readonly="catalogoProducto.catalogoRowId !== 0"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <v-text-field
                  label="Precio de venta"
                  v-model="catalogoProducto.precioVenta"
                  :rules="[
                    (v) =>
                      !!catalogoProducto.precioVenta || 'El campo es requerido',
                  ]"
                  prefix="$"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <v-text-field
                  label="Precio de renta (opcional)"
                  v-model="catalogoProducto.precioRenta"
                  prefix="$"
                  type="number"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6>
                <v-text-field
                  label="Sku o código de barras"
                  v-model="catalogoProducto.sku"
                  placeholder="Sku o código de barras"
                  hint="Sku o código de barras"
                  :rules="[
                    () => !!catalogoProducto.sku || 'El campo es requerido',
                  ]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6>
                <v-btn
                  small
                  color="primary"
                  @click="generarSku"
                  v-if="
                    catalogoProducto.tallaId !== 0 &&
                    catalogoProducto.colorId !== 0
                  "
                  >GENERAR SKU AUTOMÁTICO</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveCatalogo"
          >Guardar</v-btn
        >
      </v-card-actions>

      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Catálogo de producto guardado con éxito</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
    <snack-bar></snack-bar>
  </v-dialog>
</template>

<script>
//Components
import snackBar from "@/components/SnackBar";

//Sevices
import catalogoProductoService from "@/services/catalogoProductoService";
import colorService from "@/services/colorService";
import tallaService from "@/services/tallaService";

export default {
  components: {
    snackBar,
  },
  props: {
    catalogoProducto: {
      type: Object,
    },
    producto: {
      type: Object,
    },
  },
  watch: {
    producto: function (newProducto) {
      this.extraerTallas();
      this.extraerColores();
      this.catalogoProducto.productoId = newProducto.productoId;
    },
    catalogoProducto: function (newCatalogo) {
      this.extraerTallas();
      this.extraerColores();
    },
  },
  data() {
    return {
      showDialog: false,
      loadingTallas: false,
      tallas: [],
      loadingColores: false,
      colores: [],
    };
  },
  mounted() {
    this.extraerColores();
    this.extraerTallas();
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    extraerColores() {
      let self = this;
      self.loadingColores = true;

      colorService
        .getAll()
        .then((result) => {
          self.colores = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingColores = false;
        });
    },
    extraerTallas() {
      let self = this;
      self.loadingTallas = true;

      tallaService
        .getAllByTipoProducto(self.producto.tipoProductoId)
        .then((result) => {
          self.tallas = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingTallas = false;
        });
    },
    saveCatalogo() {
      let self = this;

      if (self.$refs.formCatalogoProducto.validate()) {
        self.operationStart();

        if (self.catalogoProducto.catalogoRowId == 0) {
          self.addCatalogo();
        } else {
          self.updateCatalogo();
        }
      }
    },
    addCatalogo() {
      let self = this;

      catalogoProductoService
        .add(self.catalogoProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onCatalogoProductoAdded", result);

          setTimeout(() => {
            self.$store.state.tituloForm = "MODIFICAR PRODUCTO";
            self.$store.state.iconoForm = "/images/general/actualizar-40.png";
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateCatalogo() {
      let self = this;
      catalogoProductoService
        .update(self.catalogoProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onCatalogoProductoUpdated", result);

          setTimeout(() => {
            self.$store.state.tituloForm = "MODIFICAR PRODUCTO";
            self.$store.state.iconoForm = "/images/general/actualizar-40.png";
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formCatalogoProducto.resetValidation();
      self.catalogoProducto.catalogoRowId = 0;
      self.catalogoProducto.sku = "";
      self.catalogoProducto.tallaId = 0;
      self.catalogoProducto.colorId = 0;
      self.catalogoProducto.precioVenta = 0;
      self.catalogoProducto.precioRenta = 0;
    },
    generarSku() {
      let self = this;

      let productoAbreviacion = self.producto.modelo;
      let linea = `L${self.zeroFill(self.producto.lineaProductoId, 1)}`;
      let marca = `M${self.zeroFill(self.producto.marcaId, 1)}`;
      let talla = `T${self.zeroFill(self.catalogoProducto.tallaId, 1)}`;
      let color = `C${self.zeroFill(self.catalogoProducto.colorId, 1)}`;
      self.catalogoProducto.sku = `${productoAbreviacion}${linea}${marca}${talla}${color}`;
    },
  },
};
</script>
